export default __webpack_public_path__ + "static/media/bestviewedindesktop.4fd0ccb0.webp";